import { render, staticRenderFns } from "./ConsentRegions.vue?vue&type=template&id=38a00b7a"
import script from "./ConsentRegions.vue?vue&type=script&lang=js"
export * from "./ConsentRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports